const initialState = {
    actionType: null,
    selected: {},
    selectedInit: {},
    latestMessages:[],
    loc:"",
    files:[],
    selectedFile:{},
    selectedMsg:{},
    selectedTab:{id: "details", label: "Details"},
    rawFiles:[],
    forUpload:[],
    isCancel:false,
    uploadActiveIndex:-1,
    inserted:false,
    selectedMessages: [],
    selectedEvents: [],
    fieldsInit: {},
    fields: {
        subject: "",
        to: [],
        workstreams: [],
        message: {},
        
    },
    fieldsEdit:{
        subject: "",
        to: [],
        workstreams: [],
        message: {},
       
    },
    showInfoModal: false,
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "UPDATE_CONVERSATIONS_ACTION_TYPE": {
            return {
                ...state,
                actionType: action.action
            }
        }

        case "UPDATE_CONVERSATIONS_SELECTED": {
            return {
                ...state,
                selected: action.selected,
                selectedInit: action.selected
            }
        }

        case "UPDATE_CONVERSATIONS_SELECTED_ONLY": {
            return {
                ...state,
                selected: action.selected
            }
        }

        case "CLEAR_CONVERSATIONS_SELECTED": {
            return {
                ...state,
                selected: {},
                selectedInit: {}
            }
        }

        case "UPDATE_CONVERSATIONS_SELECTED_MESSAGES": {
            return {
                ...state,
                selectedMessages: action.messages
            }
        }

        case "UPDATE_CONVERSATIONS_SELECTED_EVENTS": {
            return {
                ...state,
                selectedEvents: action.events
            }
        }

        case "UPDATE_CONVERSATIONS_FIELD_INIT": {
            return {
                ...state,
                fieldsInit: action.value
            }
        }

        case "UPDATE_CONVERSATIONS_FIELD": {
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.field]: action.value
                }
            }
        }
        case "UPDATE_CONVERSATIONS_FIELD_EDIT": {
            return {
                ...state,
                fieldsEdit: {
                    ...state.fieldsEdit,
                    [action.field]: action.value
                }
            }
        }

        
        case "CLEAR_CONVERSATIONS_FIELDS": {
            return {
                ...state,
                fields: initialState.fields
            };
        }
        case "CONVERSATION_UPLOADED_FILE": {
            return {
                ...state,
                files: action.files
            };
        }
        case "CONVERSATION_UPLOADED_STATUS": {
            return {
                ...state,
                isCancel: action.bool
            };
        }
        case "CONVERSATION_TOBE_UPLOAD": {
            return {
                ...state,
                forUpload: action.isAdd?[...state.forUpload,action.files]
                :state.forUpload.filter(u=>u.id !== action.files.id)
            };
        }
        case "CONVERSATION_TOBE_CLEAR": {
            return {
                ...state,
                forUpload: []
            };
        }
        case "CONVERSATION_UPLOADED_RAW": {
            return {
                ...state,
                rawFiles: action.raw,
                loc: action.loc
            };
        }
        case "CONVERSATION_FILE_INSERTED": {
            return {
                ...state,
                inserted: action.bool
            };
        }
        case "CONVERSATION_UPLOAD_ACTIVE_INDEX": {
            return {
                ...state,
                uploadActiveIndex: action.index
            };
        }
        case "SET_CONVERSATIONS_FILE_SELECTED": {
            return {
                ...state,
                selectedFile: action.selected,
            }
        }
        case "SET_CONVERSATIONS_MSG_SELECTED": {
            return {
                ...state,
                selectedMsg: action.selected,
            }
        }
        case "SET_CONVERSATIONS_TAB_SELECTED": {
            return {
                ...state,
                selectedTab: action.selected,
            }
        }
        case "SET_CONVERSATIONS_LATEST": {
            return {
                ...state,
                latestMessages: action.list,
            }
        }
        case "SET_CONVERSATIONS_SHOW_INFO_MODAL": {
            return {
                ...state,
                showInfoModal: action.showInfoModal,
            }
        }
        default:
            return state;
    }
}
